export var deleteTenant = function (str) {
    if (!str)
        return "";
    if (!(str === null || str === void 0 ? void 0 : str.includes("#")))
        return str;
    return str === null || str === void 0 ? void 0 : str.split("#")[1];
};
